document.addEventListener("DOMContentLoaded", () => {
  const addToQuoteButtons = document.querySelectorAll(".btn-add-to-quote");

  addToQuoteButtons.forEach((button) => {
    button.addEventListener("click", () => {
      const productTitle = button.getAttribute("data-product-title");
      const productHandle = button.getAttribute("data-product-handle");
      const productPrice = button.getAttribute("data-product-price");

      // Retrieve all quantity inputs for the sizes of this style
      const productRow = button.closest(".product-item");
      const sizeInputs = productRow.querySelectorAll("input[type='number']");

      let quoteList = JSON.parse(localStorage.getItem("quoteList")) || [];

      sizeInputs.forEach((input, index) => {
        const sizeHeader = productRow.querySelectorAll("table th")[index + 1];
        const size = sizeHeader ? sizeHeader.innerText.trim() : "Unknown Size";
        const quantity = parseInt(input.value);

        if (quantity > 0) {
          quoteList.push({
            title: productTitle,
            handle: productHandle,
            size: size,
            quantity: quantity,
            price: productPrice,
          });
        }
      });

      localStorage.setItem("quoteList", JSON.stringify(quoteList));
      alert(`Added "${productTitle}" to your quote list!`);
    });
  });
});
